import FilterableCell, { getRefId, resolveRef } from '@/widgets/FilterableCell'

export default function PowiatTableRow({ powiat, onWojewodztwoFilter, onNazwaClick }) {
	const powiatId = getRefId(powiat)
	const wojewodztwo = resolveRef(powiat?.id_wojewodztwo)

	return (
		<tr className="hover:bg-gray-100">
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
				<FilterableCell
					id={powiatId}
					label={powiat?.nazwa || '-'}
					onFilter={onNazwaClick}
				/>
			</td>
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
				<FilterableCell
					id={wojewodztwo.id}
					label={wojewodztwo.label}
					onFilter={onWojewodztwoFilter}
				/>
			</td>
		</tr>
	)
}
